import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import axios from "axios";
import SortButton from "../../commons/components/button/SortButton";
import _ from "lodash";
import { ROUTES } from "../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
import { MainTableWidth } from "./translationUiConst";

const SORT_NAME = {
  plant: {
    createDt: "plant-등록날짜별",
  },
  device: {
    type: "device-기기별",
    pwConsumption: "device-소비전력별",
    createDt: "device-등록날짜별",
  },
  battery: {
    capacity: "battery-용량별",
    createDt: "battery-등록날짜별",
  },
}
/* 시설 리스트 컴포넌트 */
class Main extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(window.location.search);

    this.state = {
      tabActive: parseInt(params.get("tab") || "0", 10),
      projectId: null,
      plantData: [],
      deviceData: [],
      parentIdSet: new Set(),
      batteryData: [],
      deviceTypeMapping: [],
      projectInfo: {},
      sortedPlantData: [],
      sortedDeviceData: [],
      sortedBatteryData: [],
      batteryTypeMapping: [],
      plantTypeMapping: [],
      sortState: {
        name: SORT_NAME.plant.createDt,
        active: true,
      },
      // sortBy: "createDt",
    };

    this.handleSortButtonClick = this.handleSortButtonClick.bind(this);
  }

  componentDidMount() {
    const projectId = this.props.match.params.projectId; // URL에서 마지막 부분을 추출
    this.initSortState();
    this.setState({ projectId });
    this.fetchPlantData(projectId);
    this.fetchDeviceData(projectId);
    this.fetchBatteryData(projectId);
    this.fetchType();
    this.fetchPlantType();
    this.fetchBatteryType();
  }

  componentDidUpdate(prevProps, prevState) {
    // tab url 변경 시 tabActive 변경
    if (prevProps.location.search !== this.props.location.search) {
      const params = new URLSearchParams(window.location.search);
      const tabActive = parseInt(params.get("tab") || "0", 10);
      this.setState({ tabActive });
    }

    if (prevState.sortState !== this.state.sortState || prevState.deviceData !== this.state.deviceData || prevState.plantData !== this.state.plantData || prevState.batteryData !== this.state.batteryData) {
      this.sortBySortState();
    }

  }

  initSortState() {
    let sortName = SORT_NAME.plant.createDt;
    const queryParams = new URLSearchParams(this.props.location.search);
    const tab = queryParams.get('tab');
    if (tab === '0') {
      sortName = SORT_NAME.plant.createDt;
    } else if (tab === '1') {
      sortName = SORT_NAME.device.createDt;
    } else if (tab === '2') {
      sortName = SORT_NAME.battery.createDt;
    }

    this.setState({
      sortState: {
        name: sortName,
        active: true,
      },
    });
  }

  // start: sort function

  sortBySortState() {
    const { 
      sortState: { name, active },
      plantData,
      deviceData,
      batteryData
    } = this.state;
    const sortType = active ? 'desc' : 'asc';
    const devicePriority = {
      1: 4, // 보일러 : 순서
      4: 3, // 축열조 : 순서
      2: 2, // 조명 : 순서
      3: 1  // 공조기 : 순서
    };
    switch (name) {
      case SORT_NAME.plant.createDt:
        this.setState({
          sortedPlantData: _.orderBy(plantData, ['createDt'], [sortType])
        })
        break;
      case SORT_NAME.device.type:
        this.setState({
          sortedDeviceData: _.orderBy(deviceData, [(device) => devicePriority[device.typeId]], [sortType])
        })
        break;
      case SORT_NAME.device.pwConsumption:
        this.setState({
          sortedDeviceData: _.orderBy(deviceData, ['pwConsumption'], [sortType])
        })
        break;
      case SORT_NAME.device.createDt:
        this.setState({
          sortedDeviceData: _.orderBy(deviceData, ['createDt'], [sortType])
        })
        break;
      case SORT_NAME.battery.capacity:
        this.setState({
          sortedBatteryData: _.orderBy(batteryData, ['capacity'], [sortType])
        })
        break;
      case SORT_NAME.battery.createDt:
        this.setState({
          sortedBatteryData: _.orderBy(batteryData, ['createDt'], [sortType])
        })
        break;
      default:
        break;
    }
  }


  handleSortButtonClick(event) {
    const { sortState } = this.state;

    const name = event.currentTarget.name;
    
    if (sortState.name === name && sortState.active) {
      
      this.setState({
        sortState: {
          name: name,
          active: false,
        }
      });
      return;
    }
    if (sortState.name === name && !sortState.active) {
      
      this.setState({
        sortState: {
          name: name,
          active: true,
        }
      });
      return;
    }
    if (sortState.name !== name) {
      
      this.setState({
        sortState: {
          name: name,
          active: true,
        }
      })
      return;
    }
  }
  // end: sort function

  async fetchType() {
    try {
      const response = await axios.get(`/cst/api/deviceType`);
      this.setState({ deviceTypeMapping: response.data });
    } catch (error) {
      console.error("전력기기 타입 조회 실패", error);
    }
  }

  async fetchPlantType() {
    try {
      const response = await axios.get(`/cst/api/plantType`);
      this.setState({ plantTypeMapping: response.data });
    } catch (error) {
      console.error("발전소 타입 조회 실패", error);
    }
  }

  async fetchBatteryType() {
    try {
      const response = await axios.get(`/cst/api/batteryType`);
      this.setState({ batteryTypeMapping: response.data });
    } catch (error) {
      console.error("배터리 타입 조회 실패", error);
    }
  }

  async fetchPlantData(projectId) {
    try {
      const response = await axios.get(
        `/cst/api/constructor-plant/project/${projectId}`
      );
      const resData = response.data.data;
      this.setState({ plantData: resData, sortedPlantData: resData });
    } catch (error) {
      console.error("발전소 정보 불러오기 실패", error);
    }
  }

  tabOnClick = (idx) => {
    const { history } = this.props;
    const tabActive = idx;
    // tabActive 변경 시 url 변경 (history에 기록 남기기)
    if (tabActive === 0) {
      this.setState({ sortState: { name: SORT_NAME.plant.createDt, active: true } });
    }
    if (tabActive === 1) {
      this.setState({ sortState: { name: SORT_NAME.device.createDt, active: true } });
    }
    if (tabActive === 2) {
      this.setState({ sortState: { name: SORT_NAME.battery.createDt, active: true } });
    }
    history.push(`?tab=${tabActive}`);
  };

  async fetchDeviceData(projectId) {
    let data = {
      projectId: projectId,
      sortBy: this.state.sortBy,
    };

    try {
      await axios.post("/cst/api/device/search", data).then((res) => {
        const resData = res.data.data;
        const parentIdSet = new Set(resData.filter((item) => item.parentId).map((item) => item.parentId));
        this.setState({ deviceData: resData, sortedDeviceData: resData, parentIdSet: parentIdSet });
      });
    } catch (error) {
      console.error("전력기기 정보 불러오기 실패", error);
    }
  }

  async fetchBatteryData(projectId) {
    try {
      const response = await axios.get(
        `/cst/api/battery/${projectId}`
      )
      const resData = response.data.reverse();
      
      this.setState({ batteryData: resData, sortedBatteryData: resData });
    } catch (error) {
      console.error("배터리 정보 불러오기 실패", error);
    }
  }

  onSort = (item) => {
    const priority = {
      1: 4, // 보일러 : 순서
      4: 3, // 축열조 : 순서
      2: 2, // 조명 : 순서
      3: 1  // 공조기 : 순서
    };
    const result = item.sort((a, b) => {
        return priority[a.typeId] - priority[b.typeId];
      }
    );
    this.setState({ deviceData: result });
  };

  render() {
    const { 
      plantData,
      sortedPlantData,
      projectId, 
      tabActive, 
      deviceData, 
      sortedDeviceData,
      batteryData, 
      sortedBatteryData,
      deviceTypeMapping,
      plantTypeMapping,
      batteryTypeMapping,
      sortState
    } = this.state;
    const { t, i18n } = this.props;
    const list = [
      {
        name: t('key129'),
        icon: {
          name: "panel-icon",
          src: "/images/ctors/icon/solar-panel-icon.png",
          alt: "solar-panel-icon",
        },
        link: ROUTES.PLANT_LIST(projectId).SOLAR_CREATE,
      },
      {
        name: t('key130'),
        icon: {
          name: "power-icon",
          src: "/images/ctors/icon/power-device-icon.png",
          alt: "power-device-icon",
        },
        link: ROUTES.PLANT_LIST(projectId).POWER_CREATE,
      },
      {
        name: t('key131'),
        icon: {
          name: "battery-icon",
          src: "/images/ctors/icon/blue-battery-icon.png",
          alt: "blue-battery-icon",
        },
        link: ROUTES.PLANT_LIST(projectId).BATTERY_CREATE,
      },
    ];

    return (
      <PlantListWrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">{t('key128')}</h2>
          </div>
        </div>
        <div className="container">
          <PlantTab>
            {list.map((item, idx) => (
              <PlantBox
                key={idx}
                // onClick={(event) => this.tabOnClick(idx, event)}
                className={tabActive === idx ? "on" : ""}
              >
                <LeftArea
                  onClick={(event) => this.tabOnClick(idx, event)}
                >
                  <IconBox>
                    <img
                      className={`${item.icon.name} tab-icon`}
                      src={item.icon.src}
                      alt={item.icon.alt}
                    />
                  </IconBox>
                  <h3>{item.name}</h3>
                </LeftArea>
                <RightArea>
                  <Link
                    to={{
                      pathname: item.link,
                      state: {
                        projectId: projectId,
                        deviceData: deviceData,
                        deviceTypeMapping: deviceTypeMapping,
                        plantTypeMapping: plantTypeMapping,
                        batteryTypeMapping: batteryTypeMapping,
                      }
                    }}
                    className="link-icon"
                  >
                    <img
                      src="/images/ctors/icon/create-icon.png"
                      alt="create-icon"
                    />
                  </Link>
                </RightArea>
              </PlantBox>
            ))}
          </PlantTab>
          <TotalArea>
            <p>
              <strong>{t('key132')}</strong>{t('key133')}{" "}
              {tabActive === 0 
              ? plantData.length 
              : tabActive === 1 
              ? deviceData.length 
              : batteryData.length}{t('key134')}
            </p>
            {tabActive === 1 && (
              <div style={{ display: "flex", gap: "10px" }}>
                <SortButton name={SORT_NAME.device.type} isActive={isActiveSort(sortState, SORT_NAME.device.type)} text={t('key226')} onClick={(event) => this.handleSortButtonClick(event)} />
                <SortButton name={SORT_NAME.device.pwConsumption} isActive={isActiveSort(sortState, SORT_NAME.device.pwConsumption)} text={t('key227')} onClick={this.handleSortButtonClick} />
                <SortButton name={SORT_NAME.device.createDt} isActive={isActiveSort(sortState, SORT_NAME.device.createDt)} text={t('key135')} onClick={this.handleSortButtonClick} />
              </div>
              )
            }
            {
              tabActive === 0 && <SortButton name={SORT_NAME.plant.createDt} isActive={isActiveSort(sortState, SORT_NAME.plant.createDt)} text={t('key135')} onClick={this.handleSortButtonClick}/>
            }
            {
              tabActive === 2 && (
                <div style={{ display: "flex", gap: "10px" }}>
                  <SortButton isActive={isActiveSort(sortState, SORT_NAME.battery.capacity)} name={SORT_NAME.battery.capacity} text={t('key301')} onClick={this.handleSortButtonClick}/>
                  <SortButton isActive={isActiveSort(sortState, SORT_NAME.battery.createDt)} name={SORT_NAME.battery.createDt} text={t('key135')} onClick={this.handleSortButtonClick}/>
                </div>
              )
            }
          </TotalArea>
          {tabActive === 0 ? (
            <TableContainer>
              <colgroup>
                <col width={MainTableWidth(i18n).plant[0]} />
                <col width={MainTableWidth(i18n).plant[1]} />
                <col width={MainTableWidth(i18n).plant[2]} />
                <col width={MainTableWidth(i18n).plant[3]} />
              </colgroup>
              <thead>
                <tr>
                  <th>{t('key136')}</th>
                  <th>{t('key137')}</th>
                  <th>{t('key138')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {plantData.length === 0 ? (
                  <tr>
                    {/* 등록된 시설이 존재하지 않습니다 */}
                    <td colSpan="4">{t('key529')}</td>
                  </tr>
                ) : (
                  sortedPlantData.map((plant, index) => (
                    <tr key={plant.id}>
                      <td>{index + 1}</td>
                      <td>{plant.name}</td>
                      <td>{plant.serviceWarrantyDt}</td>
                      <td>
                        {plant.typeId === 2 ? (
                          <a
                            href={plant.externalUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="detail-link"
                          >
                            {t("key139")}
                          </a>
                        ) : (
                          <Link
                            to={{
                              pathname: ROUTES.PLANT_LIST(this.state.projectId).SOLAR_DETAIL(plant.id),
                              state: {
                                projectId: this.state.projectId,
                                typeId: plant.typeId,
                              },
                            }}
                            className="detail-link"
                          >
                            {t("key139")}
                          </Link>
                        )}
                        <Link
                          to={{
                            pathname: ROUTES.PLANT_LIST(this.state.projectId).SOLAR_EDIT(plant.id),
                            state: {
                              projectId: this.state.projectId,
                              plantTypeMapping: plantTypeMapping,
                              typeId: plant.typeId,
                            },
                          }}
                          className="edit-link"
                        >
                          {t("key140")}
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </TableContainer>
          ) : tabActive === 1 ? (
            <TableContainer>
              <colgroup>
                <col width={MainTableWidth(i18n).device[0]} />
                <col width={MainTableWidth(i18n).device[1]} />
                <col width={MainTableWidth(i18n).device[2]} />
                <col width={MainTableWidth(i18n).device[3]} />
                <col width={MainTableWidth(i18n).device[4]} />
                <col width={MainTableWidth(i18n).device[5]} />
                <col width={MainTableWidth(i18n).device[6]} />
                <col width={MainTableWidth(i18n).device[7]} />
              </colgroup>
              <thead>
                <tr>
                  <th>{t('key229')}</th>
                  <th>{`${t('key230')} ${t('key231')}`}</th>
                  <th>{t('key232')}</th>
                  <th>제조사</th>
                  <th>{t('key233')}</th>
                  <th>{t('key234')}</th>
                  <th>{t('key235')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {deviceData.length === 0 ? (
                  <tr>
                    {/* 등록된 전력기기가 존재하지 않습니다. */}
                    <td colSpan="8">{t('key530')}</td>
                  </tr>
                ) : (
                  sortedDeviceData.map((device, index) => (
                    <tr key={device.id}>
                      <td>{index + 1}</td>
                      <td>
                        {this.state.deviceTypeMapping.find(
                          (mapping) => mapping.id === device.typeId
                        )?.type || "알수없음"}
                      </td>
                      <td>{device.name}</td>
                      <td>{device.deviceCompany}</td>
                      <td>{device.modelName}</td>
                      <td>{device.pwConsumption} kW</td>
                      <td>{device.serviceWarrantyDt}</td>
                      <td>
                        {
                          !this.state.parentIdSet.has(device.id) && device.typeId === 4 ? (
                            <span className="disabled-link">{t('key236')}</span>
                          ) : device.typeId === 2 ? (
                            <a
                              href={device.externalUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="detail-link"
                            >
                              {t('key236')}
                            </a>
                          ) : (
                            <Link
                              to={{
                                pathname: ROUTES.PLANT_LIST(this.state.projectId).POWER_DETAIL_CARRIER,
                                state: {
                                  projectId: this.state.projectId,
                                  device: device,
                                  deviceList: deviceData,
                                },
                              }}
                              className="detail-link"
                            >
                              {t('key236')}
                            </Link>
                          )
                        }
                        <Link
                          to={{
                            pathname: ROUTES.PLANT_LIST(this.state.projectId).POWER_EDIT(device.id),
                            state: {
                              projectId: this.state.projectId,
                              device: device,
                              deviceData: deviceData,
                              deviceTypeMapping: deviceTypeMapping,
                            },
                          }}
                          className="edit-link"
                        >
                          {t('key237')}
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </TableContainer>
          ) : (
            <BatteryListTab betteryData={sortedBatteryData} projectId={this.state.projectId} t={t} i18n={i18n} batteryTypeMapping={batteryTypeMapping} />
          )}
        </div>
      </PlantListWrap>
    );
  }
}

class BatteryListTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { betteryData, projectId, t, i18n } = this.props;
    return (
      <TableContainer>
        <colgroup>
          <col width={MainTableWidth(i18n).battery[0]} />
          <col width={MainTableWidth(i18n).battery[1]} />
          <col width={MainTableWidth(i18n).battery[2]} />
          <col width={MainTableWidth(i18n).battery[3]} />
          <col width={MainTableWidth(i18n).battery[4]} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('key303')}</th>
            <th>{t('key304')}</th>
            <th>{t('key305')}</th>
            <th>{t('key306')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            betteryData.length === 0 ? (
              <tr>
                {/* 등록된 배터리가 존재하지 않습니다 */}
                <td colSpan="5">{t('key532')}</td>
              </tr>
            ) : (
              betteryData.map((battery, idx) => (
                <tr key={battery.id}>
                  <td>{idx + 1}</td>
                  <td>{battery.name}</td>
                  <td>{battery.capacity} kWh</td> 
                  <td>{battery.serviceWarrantyDt}</td>
                  <td>
                    {battery.typeId === 2 ? (
                      <a
                        href={battery.externalUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="detail-link"
                      >
                        {t('key307')}
                      </a>
                    ) : (
                      <Link
                        to={{
                          pathname: ROUTES.PLANT_LIST(projectId).BATTERY_DETAIL(battery.id),
                          state: {
                            projectId: projectId,
                            battery: battery,
                            batteryList: betteryData,
                          }
                        }}
                        className="detail-link"
                      >
                        {t('key307')}
                      </Link>
                    )}
                    <Link 
                      to={{
                        pathname: ROUTES.PLANT_LIST(projectId).BATTERY_EDIT(battery.id),
                        state: {
                          projectId: projectId,
                          battery: battery,
                          batteryList: betteryData,
                          batteryTypeMapping: this.props.batteryTypeMapping,
                        }
                      }} 
                      className="edit-link"
                    >
                      {t('key140')}
                    </Link>
                  </td>
                </tr>
              ))
            )
          }
        </tbody>
      </TableContainer>
    );
  }
}

const PlantListWrap = styled.div`
  min-height: 100vh;
`;
const PlantTab = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  padding: 50px 0;
`;
const PlantBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0;
  height: 100px;
  background-color: var(--grey-50);
  border: 1px solid var(--grey-200);
  border-radius: 6px;
  padding: 0 25px;
  cursor: pointer;
  &.on {
    background-color: transparent;
  }
  &:hover {
    border: 1px solid var(--secondary-500);
  }
`;
const LeftArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  vertical-align: middle;
  width: calc(100% - 40px);
  height: 100px;
  h3 {
    display: inline-block;
    vertical-align: middle;
    font-size: 22px;
    font-size: 600;
    color: #191919;
  }
`;
const IconBox = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 15px;
  .tab-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    object-fit: contain;
  }

  .panel-icon {
    width: 58px;
    height: 50px;
  }
  .power-icon {
    width: 38px;
    height: 52px;
  }
  .battery-icon {
    width: 59px;
    height: 37px;
  }
`;
const RightArea = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;

  .link-icon {
    display: block;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;
const TotalArea = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  align-items: center;
  margin-bottom: 15px;
  p {
    text-align: left;
    strong {
      display: inline-block;
      vertical-align: middle;
      font-size: 15px;
      color: #191919;
      font-weight: bold;
      padding-right: 10px;
    }
    display: inline-block;
    vertical-align: middle;
    font-size: 15px;
    font-weight: 400;
    color: #888e98;
  }
  // button {
  //   padding: 4px 8px;
  //   border: 1px solid #d5d8de;
  //   background-color: #d5d8de;
  //   border-radius: 5px;
  //   color: #191919;
  //   font-size: 15px;
  //   font-weight: 500;
  //   img {
  //     display: inline-block;
  //     vertical-align: middle;
  //     width: 16px;
  //     height: 16px;
  //     object-fit: contain;
  //   }
  // }
`;

const TableContainer = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    text-align: center;
    padding: 10px;
    font-size: 14px;
  }
  th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #e3e5e7;
  }
  td {
    border-bottom: 1px solid #e3e5e7;
    a {
      text-decoration: none;
      font-size: 12px;
      border-radius: 5px;
      padding: 5px 10px;
    }
    .detail-link {
      background-color: var(--primary-500);
      color: var(--grey-900);
      margin-right: 5px;
    }
    .detail-link:hover {
      background-color: var(--primary-600);
    }
    .disabled-link {
      background-color:rgb(232, 222, 195);
      cursor: not-allowed;
      margin-right: 5px;
      font-size: 12px;
      border-radius: 5px;
      padding: 5px 10px;
      color: #888e98;
    }
    .edit-link {
      background-color: var(--secondary-500);
      color: var(--white);
    }
    .edit-link:hover {
      background-color: var(--secondary-600);
    }
  }
`;

const DisabledLink = styled.span`

`;
export default withTranslation()(Main);

function isActiveSort(sortState, name) {
  return sortState.name === name && sortState.active;
}

